// News Article class : for news section
export class News {
  index: number;
  url: string;
  title: string;

  public subtitle: string;

  shortDescription: string;
  content: string[];
  link: string;

  isActive: boolean;
  isExternal: boolean;

  constructor(
    _index: number,
    _title: string,
    _subtitle: string,
    _shortDesc: string,
    _content: string[],
    _link: string) {
    this.index = _index;
    this.title = _title;
    this.url = encodeURIComponent(_title.replace(/ /g, '-').toLocaleLowerCase());
    this.subtitle = _subtitle;
    this.shortDescription = _shortDesc;
    this.content = _content;
    this.link = _link;
    this.isActive = false;

    if (_content.length > 0 && _link.length < 1) {
      this.isExternal = false;
    } else if (_content.length < 1 && _link.length > 0) {
      this.isExternal = true;
    }
  }
}

// Event class : for event section
export class Event {
  title: string;
  shortDescription: string;
  content: string[];

  isExternal: boolean;
  url: string;

  company: string;

  day: string;
  month: string;

  top: string;
  bottom: string;

  registration_link: string;

  email: string;
  EventDate: Date;

  constructor(_isExternal: boolean, _title: string, _shortDesc: string, _content: string[], _comp: string, _day: string, _month: string, _top: string, _bottom: string, _registration_link: string, _email: string, _date: Date) {
    this.title = _title;
    this.shortDescription = _shortDesc;
    this.content = _content;
    this.EventDate = _date;
    this.company = _comp;

    this.day = _day;
    this.month = _month;

    this.top = _top;
    this.bottom = _bottom;

    // twitter or registration link
    this.registration_link = _registration_link;

    this.email = _email;

    this.isExternal = _isExternal;
    if (this.isExternal && this.content.length == 0) {
      this.url = this.registration_link;
    } else {
      this.url = _title.replace(/ /g, '-').toLocaleLowerCase();
    }
  }
}

// Team Member class : for team carousel and service wheel
export class TeamMember {
  // position
  index: number;

  // details
  fullname: string;
  position: string;
  email: string;
  genericEmail: string;
  mobile: string;

  // linkedin: string;

  // image
  image: string;

  description: string;
  isActive: boolean;

  constructor(_index: number, _name: string, _surname: string, _email: string, _position: string, _mobile: string, _image: string, _description: string, _active: boolean, _genericEmail?: string) {
    this.index = _index;
    this.fullname = _name + ' ' + _surname;
    this.position = _position;
    this.email = _email;
    this.mobile = _mobile;
    // this.linkedin = _linkedin;
    this.image = _image;
    this.description = _description;
    this.isActive = _active;
    if (!_genericEmail) {
      this.genericEmail = _email;
    } else {
      this.genericEmail = _genericEmail;
    }
  }
}

// ServiceProduct class : for service wheel
export class ServiceProduct {
  companyName: CompanyEnum;

  member: TeamMember;
  memberFullName: string;
  memberPicture: string;
  memberEmail: string;
  memberMobile: string;
  // memberLinkedIn: string;

  serviceName: string;
  serviceContent: string;
  serviceContentLines: string[];

  linkTo: string;

  constructor(_companyName: CompanyEnum, _member: TeamMember, _serviceName: string, _serviceContent: string, _linkTo: string, _serviceContentLines?: string[] ) {
    this.companyName = _companyName;

    this.member = _member;
    this.memberFullName = _member.fullname;
    this.memberPicture = _member.image;
    this.memberEmail = _member.email;
    if (_member.genericEmail) {
      this.memberEmail = _member.genericEmail;
    }

    this.memberMobile = _member.mobile;
    // this.memberLinkedIn = _member.linkedin;

    this.serviceName = _serviceName;
    this.serviceContent = _serviceContent;
    this.serviceContentLines = _serviceContentLines;
    this.linkTo = _linkTo;
  }
}

export enum CompanyEnum {
  PI = 0,
  RS,
  GS,
  CC,
  FCI,
  DATA
}
